<template>
  <!-- CMS 画像のみ Cloudflare 変換を通す。画像なし時の noImage はバンドルSVGのため変換に通さず素の <img> で出す -->
  <OptimizedImage
    v-if="src"
    class="h-full w-full object-cover transition-transform duration-500 md:group-hover:scale-[1.04] md:group-hover:will-change-transform"
    loading="lazy"
    :alt="alt || 'no-image'"
    :image-url="src"
    :optimized-image-options="{ width: variant === 'large' ? 1216 : 640 }"
  />
  <img
    v-else
    class="h-full w-full object-cover transition-transform duration-500 md:group-hover:scale-[1.04] md:group-hover:will-change-transform"
    loading="lazy"
    :alt="alt || 'no-image'"
    :src="noImage"
  />
  <!-- Progressive Blur: MainVisualSectionCMS と同じ手法で、backdrop-blur と mask による
       linear-gradient で擬似 ProgressiveBlur を再現する。テキスト領域に向かって徐々に
       ブラー強度を上げ、視認性を確保しつつ画像の連続性を残す。
       カード高さに対する比率を揃えるため、大カード=160px / 小カード=100px とする
       （いずれもカード高に対して約 25%）。 -->
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/20 via-black/10 to-transparent backdrop-blur-[12px]"
    :class="variant === 'large' ? 'h-[160px]' : 'h-[100px]'"
    :style="{
      mask: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 8%, rgba(0,0,0,0.2) 16%, rgba(0,0,0,0.3) 24%, rgba(0,0,0,0.4) 32%, rgba(0,0,0,0.5) 40%, rgba(0,0,0,0.6) 48%, rgba(0,0,0,0.7) 56%, rgba(0,0,0,0.8) 64%, rgba(0,0,0,0.9) 72%, rgba(0,0,0,1) 80%)',
      WebkitMask:
        'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 8%, rgba(0,0,0,0.2) 16%, rgba(0,0,0,0.3) 24%, rgba(0,0,0,0.4) 32%, rgba(0,0,0,0.5) 40%, rgba(0,0,0,0.6) 48%, rgba(0,0,0,0.7) 56%, rgba(0,0,0,0.8) 64%, rgba(0,0,0,0.9) 72%, rgba(0,0,0,1) 80%)',
    }"
  />
  <!-- ブラー上に重ねる黒色グラデーション。テキスト可読性を底上げする。 -->
  <div aria-hidden="true" class="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/50 to-transparent" :class="variant === 'large' ? 'h-[160px]' : 'h-[100px]'" />
</template>

<script lang="ts" setup>
import noImage from '@/assets/img/no-image.svg';
import OptimizedImage from '@/wabunka-src/common/components/stateful/OptimizedImage/OptimizedImage.vue';

interface Props {
  src: string;
  alt: string;
  variant?: 'small' | 'large';
}

withDefaults(defineProps<Props>(), {
  variant: 'small',
});
</script>
